import { Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { ItemLocation } from '@app/shared/enums/ItemLocation.enum';

@Pipe({
    name: "itemLocationPipe",
    standalone: false
})
export class ItemLocationPipe implements PipeTransform {
  public operationType = ItemLocation;
  public itemLocationTypes: any[] = [];

  constructor(public translate: TranslateService) {
    this.getList();
  }

  transform(key: any): any {
    for (let item in this.operationType) {
      if (this.operationType[item] === key)
        return this.translate.instant('ENUMS.ITEM_LOCATION_' + key);
    }
  }

  getList() {
    this.itemLocationTypes = [];
    for (const [propertyKey, propertyValue] of Object.entries(ItemLocation)) {
      if (!Number.isNaN(Number(propertyKey))) {
        continue;
      }
      const nameAndText = this.translate.instant('ENUMS.ITEM_LOCATION_' + propertyKey);
      this.itemLocationTypes.push({id: propertyKey, name: nameAndText, text: nameAndText});
    }

    return this.itemLocationTypes;
  }

  getById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(ItemLocation)) {
      if (propertyValue == Id) {
        const nameAndText = this.translate.instant('ENUMS.' + propertyKey);
        return {id: propertyValue, name: nameAndText, text: nameAndText};
      }
    }
    return null
  }

  getNameById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(ItemLocation)) {
      if (propertyValue == Id) {
        return 'ENUMS.' + propertyKey;
      }
    }
    return null
  }
}
